import { useEffect } from 'react';

type PageProps = {
  title: string;
} & React.HTMLAttributes<HTMLDivElement>;

const Page = ({ title, children }: PageProps) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return children;
}

export default Page;